<template>
  <UiTooltip
    v-if="hasContent"
    position="top"
    :fixed="true"
    :auto-flip="true"
    variant="activity-user-profile"
  >
    <template #trigger>
      <span class="activity-date-hover-tooltip__trigger">
        <slot />
      </span>
    </template>
    <div class="activity-date-hover-tooltip__body">
      <p v-if="createdDate" class="activity-date-hover-tooltip__line">{{ t('common.activityCard.createdDateLabel') }} : {{ createdDate }}</p>
      <p v-if="activityDate" class="activity-date-hover-tooltip__line">{{ t('common.activityCard.activityDateLabel') }} : {{ activityDate }}</p>
    </div>
  </UiTooltip>
  <span v-else class="activity-date-hover-tooltip__trigger">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const { t } = useI18n();
const props = defineProps({
  createdDate: {
    type: String,
    default: '',
  },
  activityDate: {
    type: String,
    default: '',
  },
});

const hasContent = computed(() => !!(props.createdDate || props.activityDate));
</script>

<style scoped lang="scss">
.activity-date-hover-tooltip__trigger {
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  cursor: default;
}
</style>

<style lang="scss">
/* Teleport(body) 툴팁 — 활동 카드 날짜 */
.ui-tooltip.ui-tooltip--activity-user-profile {
  .activity-date-hover-tooltip__line {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.45;
    color: #fff;
  }

  .activity-date-hover-tooltip__line + .activity-date-hover-tooltip__line {
    margin-top: 2px;
  }
}
</style>
